// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"85e166b8","239":"6e95697c","453":"4c8431bf","702":"b5ee41d7","732":"d0bf6864","977":"27644978"}[chunkId] + ".chunk.js";
};